<template>
  <div> 
  <!-- <router-view :key="$route.path"/> -->
  <router-view/>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>
<style>
#app {
  background-color: var(--v-background-base);
}
</style>
